(function () {
  'use strict';

  (function () {
    new themegoal.helpers.Responsive();
    new TG_ProductCardColorSwatch();
    let windowWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      let newWidth = window.innerWidth;

      if (newWidth === windowWidth) {
        return;
      }

      let headerSection = document.getElementById('Header');
      let announcementBarSection = document.getElementById('AnnouncementBar');
      let pageHeader = document.getElementById('PageHeader');
      windowWidth = newWidth;
      document.documentElement.style.setProperty('--tg-window-height', window.innerHeight + 'px');

      if (headerSection) {
        document.documentElement.style.setProperty('--tg-header-height', headerSection.offsetHeight + 'px');
      }

      if (announcementBarSection) {
        document.documentElement.style.setProperty('--tg-announcement-bar-height', announcementBarSection.offsetHeight + 'px');
      }

      if (pageHeader) {
        document.documentElement.style.setProperty('--tg-page-header-height', pageHeader.offsetHeight + 'px');
      }
    });
  })();

})();

document.addEventListener('DOMContentLoaded', function () {
  const ALL_REVIEWS_URL = '/pages/reviews'; // <-- replace with your reviews page URL

  function insertViewAllBtn() {
    const header = document.querySelector('.jdgm-carousel-title-and-link');
    if (!header) return;

    // Avoid duplicates
    if (header.querySelector('.jdgm-view-all-btn')) return;

    const btn = document.createElement('a');
    btn.href = ALL_REVIEWS_URL;
    btn.className = 'jdgm-view-all-btn';
    btn.textContent = 'View All Reviews';

    header.appendChild(btn);
  }

  // Run now
  insertViewAllBtn();

  // Re-run if Judge.me re-renders the widget
  const observer = new MutationObserver(() => insertViewAllBtn());
  observer.observe(document.body, { childList: true, subtree: true });
});


